import Tag from "./Tag";

const ExperienceTimeline = ({ experiences }) => (
  <div>
    {experiences.map((job) => (
      <div
        key={job.company}
        className="grid sm:grid-cols-[9rem_1fr] gap-3 sm:gap-6"
      >
        <p className="text-xs font-mono text-muted pt-1">{job.duration}</p>
        <div className="border-l border-border pl-5 relative pb-10">
          <span className="absolute -left-[5px] top-1.5 w-2 h-2 rounded-full bg-accent ring-4 ring-ink" />
          <h3 className="text-lg font-semibold text-white">
            {job.role}{" "}
            {job.link ? (
              <a
                href={job.link}
                target="_blank"
                rel="noreferrer"
                className="text-accent hover:underline"
              >
                · {job.company}
              </a>
            ) : (
              <span className="text-accent">· {job.company}</span>
            )}
          </h3>
          <p className="text-xs text-muted mt-0.5">{job.country}</p>
          {job.bullets.length > 0 && (
            <ul className="mt-3 space-y-2">
              {job.bullets.map((bullet, i) => (
                <li
                  key={i}
                  className="text-sm text-muted leading-relaxed list-disc list-inside marker:text-border"
                >
                  {bullet}
                </li>
              ))}
            </ul>
          )}
          {job.tools && (
            <div className="flex flex-wrap gap-2 mt-4">
              {job.tools.split(", ").map((tool) => (
                <Tag key={tool}>{tool}</Tag>
              ))}
            </div>
          )}
        </div>
      </div>
    ))}
  </div>
);

export default ExperienceTimeline;
